<section class="error-area ptb-100">
    <div class="container">
        <div class="error">
            <h1>404</h1>
            <p>We're sorry but it looks like that page doesn't exist anymore.</p>
          
        </div>
    </div>
</section>